import { render, staticRenderFns } from "./create-sales-order-request.vue?vue&type=template&id=2633509e&"
import script from "./create-sales-order-request.vue?vue&type=script&lang=ts&"
export * from "./create-sales-order-request.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports